import LegalPage from "../components/LegalPage";
import { COMPLAINTS_SECTIONS, GALLERY } from "../data/content";

const Complaints = () => (
  <LegalPage
    testId="complaints-page"
    path="/complaints"
    seoTitle="Complaints Procedure"
    seoDescription="How to make a complaint to BTK Mortgage Services or PRIMIS Mortgage Network, and how to escalate to the Financial Ombudsman Service."
    eyebrow="Legal · Complaints"
    title="Complaints procedure."
    italic="If something's gone wrong, tell us."
    intro="We take complaints seriously and want to put things right. Here's exactly how it works, and what to do if you're still not happy."
    image={GALLERY[4]}
    sections={COMPLAINTS_SECTIONS}
  />
);

export default Complaints;
